import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
} from '@mui/material';

export const Confirm = ({ grid, question, onChange, checked, ...rest }) => (
  <Grid item className="confirm" xs={grid || 12}>
    <FormGroup className={rest.error ? 'error' : ''}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={({ target: { checked } }) => onChange(checked.toString())}
          />
        }
        label={question}
      />
      {rest.error ? <FormHelperText>{rest.helperText}</FormHelperText> : null}
    </FormGroup>
  </Grid>
);
